import { ChangeDetectionStrategy, Component, inject, output, signal } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { APP_CONFIG, AppConfig, PlatformSourceEnum, UsersService } from '@smartcharge/shared/index';

import { AuthView, AuthViewState } from '../auth.component';
import { log } from 'console';

@Component({
  selector: 'sc-forgot-password',
  standalone: false,
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ForgotPasswordComponent {
  readonly form = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email])
  });

  readonly loading = signal<boolean>(false);
  readonly showPassword = signal<boolean>(false);

  readonly close = output<boolean>();
  readonly switchView = output<AuthViewState>();

  private readonly appConfig: AppConfig = inject(APP_CONFIG);
  private readonly usersService = inject(UsersService);

  submit() {
    console.log(this.form);
    if (this.form.invalid) {
      return;
    }

    this.loading.set(true);

    const { email } = this.form.value;

    this.usersService
      .resetPassword({
        AppToken: this.appConfig.appToken,
        Mail: email!,
        Source: PlatformSourceEnum.App
      })
      .subscribe({
        next: () => {
          this.loading.set(false);

          this.switchView.emit({ view: 'login', config: { method: 'email', passwordResetSent: true } });
        },
        error: () => {
          this.loading.set(false);
        }
      });
  }
}
